// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"df55b752334be01e7e4d","195":"d365ea26bf8f7b4a9f68","243":"307c1cf31df043fbcfea","643":"9859567f79be40140479","658":"17e64130357f10c1b534","688":"dca761db29c8dad734c1"}[chunkId] + ".bundle.js";
};